// extracted by mini-css-extract-plugin
export var button = "_92-4";
export var hasDarkBackground = "_92-7";
export var hasLightBackground = "_92-6";
export var iconWrapper = "_92-0";
export var large = "_92-2";
export var medium = "_92-1";
export var small = "_92-5";
export var xsmall = "_92-3";